module.exports = __webpack_public_path__ + "static/mbl_application@2x.bcea68c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/mbl_application@2x.png
// module id = 675
// module chunks = 193162123475590